import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSeo } from '../lib/seo';

export default function NotFound() {
  useSeo({
    title: '404 — Halaman Tidak Ditemukan',
    description: 'Halaman yang Anda cari tidak tersedia atau telah dipindahkan.',
    noindex: true,
  });
  return (
    <div className="min-h-screen bg-white" data-testid="not-found-page">
      <Header />
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <p className="font-heading font-black text-7xl text-brand-black tracking-tighter">404</p>
        <h1 className="font-heading font-bold text-2xl mt-4">Halaman Tidak Ditemukan</h1>
        <p className="text-zinc-500 text-sm mt-3 max-w-md mx-auto">
          Halaman yang Anda cari tidak tersedia, telah dipindahkan, atau URL yang dimasukkan salah.
        </p>
        <div className="flex items-center justify-center gap-3 mt-8">
          <Link to="/" data-testid="notfound-home-link"
            className="bg-brand-black text-white px-6 py-3 text-sm font-medium hover:bg-brand-red transition-colors">
            Kembali ke Beranda
          </Link>
          <Link to="/produk" data-testid="notfound-catalog-link"
            className="border border-border px-6 py-3 text-sm font-medium hover:border-brand-black transition-colors">
            Jelajahi Produk
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
